export var QUERY_STATE;
(function (QUERY_STATE) {
    QUERY_STATE["SUCCESS"] = "SUCCESS";
    QUERY_STATE["WAITING"] = "WAITING";
    QUERY_STATE["FAIL"] = "FAIL";
    QUERY_STATE["EMPTY"] = "EMPTY";
})(QUERY_STATE || (QUERY_STATE = {}));
//# sourceMappingURL=constants.js.map